import { Box, styled } from "@mui/material";
import { SwooshIllustration, PrimaryContainer } from "react-common-ui-library";
import SwooshIcon from "./SwooshIcon";

export const StyledParentBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== "isOverLappingFooter",
})(({ theme, isOverLappingFooter }) => ({
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: isOverLappingFooter
    ? theme.palette.background.primary
    : theme.palette.background["default"],
}));

export const StyledChildBox = styled(Box)(({ theme }) => ({
  flex: 1,
  [theme.breakpoints.up("sm")]: {
    background: `no-repeat url(${SwooshIllustration()})`,
    backgroundPosition: "bottom -1px left",
    backgroundSize: "100%",
  },
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  [theme.breakpoints.down("sm")]: {
    backgroundColor: theme.palette.background.paper,
  },
  [theme.breakpoints.up("xs")]: {
    marginTop: 0,
  },
  [theme.breakpoints.up("md")]: {
    marginTop: theme.spacing(5),
  },
}));

export const StyledPrimaryContainer = styled(PrimaryContainer)(({ theme }) => ({
  marginTop: theme.spacing(5),
}));

export const StyledSwooshIconBox = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "flex",
  alignItems: "flex-end",
  justifyContent: "center",
  marginTop: theme.spacing(10),
  marginBottom: "-3px",
}));

export const StyledSwooshIcon = styled(SwooshIcon)(() => ({
  flexBasis: "100%",
  flexGrow: 1,
  width: "auto",
  height: "100%",
}));

export const StyledLoginChildBox = styled(Box)(() => ({
  flex: 1,
  display: "flex",
}));
